import Service from "./Service";
const baseurl = '/api/factores-riesgo';

export default {
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    getByUsuario(idUsuario) {
        return Service.get(`${baseurl}/by-usuario/${idUsuario}`);
    },
    getByHistoria(idHistoria) {
        return Service.get(`${baseurl}/by-historia/${idHistoria}`);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    }
};
